module.exports = __webpack_public_path__ + "img/test.052bbebd.png";